import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AnonymousReviewProvider } from './AnonymousReviewProvider';
import AnonymousStep1 from './AnonymousStep1';
import AnonymousStep2 from './AnonymousStep2';
import AnonymousStep3 from './AnonymousStep3';
import AnonymousRegister from './AnonymousRegister';
import AnonymousFinalPage from './AnonymousFinalPage';
import ApproviaFooter from '../ApproviaFooter';

const AnonymousReviewFlow: React.FC = () => {
  return (
    <AnonymousReviewProvider>
      <div className="min-h-screen bg-background flex flex-col">
        <div className="flex-1">
          <div className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<Navigate to="step-1" replace />} />
              <Route path="step-1" element={<AnonymousStep1 />} />
              <Route path="step-2" element={<AnonymousStep2 />} />
              <Route path="step-3" element={<AnonymousStep3 />} />
              <Route path="register" element={<AnonymousRegister />} />
              <Route path="final" element={<AnonymousFinalPage />} />
            </Routes>
          </div>
        </div>
        <ApproviaFooter />
      </div>
    </AnonymousReviewProvider>
  );
};

export default AnonymousReviewFlow; 